module.exports = __webpack_public_path__ + "img/Premium Sleep02.75e2f3b6.png";